var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStitching(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2533_25326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 70.6667C56.5685 70.6667 70 57.2352 70 40.6667C70 24.0981 56.5685 10.6667 40 10.6667C23.4315 10.6667 10 24.0981 10 40.6667C10 57.2352 23.4315 70.6667 40 70.6667Z",
    fill: "#C1E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2549 50.8643H11.9614V65.7373H68.2549V50.8643Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.99,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3818 59.9329L21.8955 56.4193",
    stroke: "#0C57BF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.396 59.9329L29.8823 56.4193",
    stroke: "#0C57BF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.396 59.9329L36.9143 56.4193",
    stroke: "#0C57BF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4282 59.9329L36.9146 56.4193",
    stroke: "#0C57BF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4282 59.9329L43.9419 56.4193",
    stroke: "#0C57BF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4602 59.9329L43.9419 56.4193",
    stroke: "#0C57BF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.46 59.9329L50.9736 56.4193",
    stroke: "#0C57BF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4873 59.9329L50.9736 56.4193",
    stroke: "#0C57BF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4873 59.9329L58.0057 56.4193",
    stroke: "#0C57BF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5195 59.9329L58.0059 56.4193",
    stroke: "#0C57BF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0933 27.0543C30.7904 28.2114 34.892 28.7335 36.9146 30.2198C41.1432 33.329 41.1432 40.662 30.8281 49.1098C20.5129 57.5623 26.369 59.9329 26.369 59.9329L29.8826 56.4193",
    stroke: "#0C57BF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.316 21.5039C27.6058 21.3769 26.9378 21.8614 26.8297 22.5764L21.8955 56.4193L29.3414 23.0185C29.4872 22.313 29.0216 21.6309 28.3113 21.5039H28.316Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0913 33.3666L27.6576 23.3478C27.6859 23.1502 27.8693 23.0185 28.0668 23.0515C28.2597 23.0844 28.3914 23.2725 28.3491 23.4701L26.0913 33.3666Z",
    fill: "#1F2025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1437 7.57639C34.1437 7.57639 19.8822 9.58956 19.6376 18.9075C19.5106 23.7664 23.0619 25.789 27.0929 27.0543",
    stroke: "#0C57BF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2533_25326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0 0.666687)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStitching);
export default __webpack_public_path__ + "static/media/stitching.dbd145738794386849999e234fdcb77d.svg";
export { ForwardRef as ReactComponent };